import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ButtonContainer = styled.div`
  position: fixed;
  bottom: 40px;
  right: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  gap: 8px;

  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
  }
`;

const ButtonText = styled.div`
  background-color: #25D366;
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
`;

const FloatingButton = styled.a`
  width: 75px;
  height: 75px;
  background-color: #25D366;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 38px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
    background-color: #20BA5C;
    color: #fff;
  }

  @media (max-width: 768px) {
    width: 65px;
    height: 65px;
    font-size: 32px;
  }
`;

const WhatsAppButton = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  
  return (
    <ButtonContainer>
      <ButtonText>
        {isArabic ? 'احجز الآن' : 'Book Now'}
      </ButtonText>
      <FloatingButton 
        href="https://wa.me/966558507990"
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp />
      </FloatingButton>
    </ButtonContainer>
  );
};

export default WhatsAppButton;
